import { theme } from "theme/theme";
import { cn, colors } from "tools/ui";
import FormField from "./FormField";

const style = "w-full py-2 px-2 text-right";
const PATTERN = /^-?\d*\.?\d{0,6}$/;
const formatter = Intl.NumberFormat("en-US");

/**
 *
 * @param {*} props -
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} label -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component TextField
 */
function Float(props) {
  const {
    name,
    field,
    data,
    label,
    readOnly,
    placeholder,
    onChange,
    icon,
    format,
    rounded,
    decimalPlaces,
    colSpan,
    model,
  } = props;
  const _value = data.value || "";

  const _style = style;

  let _color = "bg-white";
  if (readOnly) {
    _color = colors.readOnly;
  }

  function handleChange(event) {
    let _value = event.target.value;
    _value = _value.replaceAll(",", "");
    const validNumber = PATTERN.test(_value);

    if (!validNumber) {
      return;
    }
    data.value = _value;
  }

  const onBlur = () => {
    let _value;
    if (data.value && data.value !== "") {
      _value = data.value.replaceAll(",", "");
      _value = parseFloat(_value).toFixed(decimalPlaces || 0);
      _value = _value.toString();
    } else {
      _value = 0;
    }
    data.value = formatter.format(_value);
    if (onChange) {
      onChange(name, _value);
    }
  };

  let moreTools;
  if (format === "percent") {
    moreTools = <p className="pl-2 my-auto text-stone-700 text-sm">%</p>;
  }
  if (rounded && data?.value) {
    let _value = Math.round(parseFloat(data?.value.replace(/,/g, "")) || 0);
    data.value = formatter.format(_value);
  }

  return (
    <FormField
      label={label}
      name={name}
      required={field.required}
      colspan={colSpan}
      model={model}
    >
      <input
        key={name}
        id={name}
        name={name}
        className={cn(
          _color,
          _style,
          theme.textColor,
          theme.border,
          theme.input.height,
          theme.input.text,
        )}
        type="text"
        value={data.value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={readOnly ?? false}
        placeholder={placeholder ?? ""}
      />
      {icon || null}
    </FormField>
  );
}

export default Float;
